module.exports = __webpack_public_path__ + "img/Boolflix-logo.8a206c24.png";